// extracted by mini-css-extract-plugin
export var sliderRange = "_cz-2";
export var sliderRoot = "_cz-0";
export var sliderThumb = "_cz-3";
export var sliderTrack = "_cz-1";